<template>
  <base-dialog
    :title="'house.param.fireplaces.title' | i18n"
    :subtitle="'house.param.fireplaces.subtitle' | i18n"
    :description="'house.param.fireplaces.description' | i18n">

    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/house_fireplaces.png" />
        </div>

        <div class="col-8">
          <label>Tulisijojen määrä kpl</label>
          <select v-model="numOfFireplaces" class="form-control">
            <option v-for="n in 10" :value="n-1">{{ n-1 }}</option>
          </select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import BaseDialog from "./BaseDialog"

  export default {
    computed: {
      numOfFireplaces: {
        get() {
          return this.$store.state.houseParams.numOfFireplaces
        },
        set(numOfFireplaces) {
          this.$store.commit('houseParams/SET_NUM_OF_FIREPLACES', numOfFireplaces)
        }
      }
    },

    created() {
      if(this.numOfFireplaces == null) {
        this.numOfFireplaces = 0
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseFireplacesDialog.vue